import React from 'react'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    opacity: '0.7',
    fontSize: theme.size.base,
    color: '#E8E8E8',
    margin: '2rem',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column'
    }
  },

  logo: {
    height: '1.5rem',
    marginLeft: '0.25rem'
  }
}))

const Copyright = props => {
  const classes = useStyles()

  const year = new Date().getFullYear()

  return (
    <div className={classes.root}>
      © {year}{' '}
      <img src='/imgs/new-logo.svg' alt='Logo' className={classes.logo} />
    </div>
  )
}

export default Copyright
